import Configuration from './Configuration';

export function getIdpTenantUrl(): string {
  if (process.env.REACT_APP_IDP_TENANT_URL) {
    return process.env.REACT_APP_IDP_TENANT_URL;
  }

  if (Configuration.Current().isOktaHosting) {
    return `${document.location.origin}/`;
  }

  if (process.env.REACT_APP_USER_TYPE.toLowerCase() === 'partner') {
    return process.env.REACT_APP_IDP_TENANT_URL_PARTNERS;
  }

  if (process.env.REACT_APP_AW_AUTHENTICATION_COMPANY.toLowerCase() === 'ia') {
    return process.env.REACT_APP_IDP_TENANT_URL_IA;
  }

  if (process.env.REACT_APP_AW_AUTHENTICATION_COMPANY.toLowerCase() === 'investia') {
    return process.env.REACT_APP_IDP_TENANT_URL_INVESTIA;
  }

  return null;
}
